import React from "react";

const FilterOptionsMenu = ({ options, value, onSelect, className = "", style }) => {
  return (
    <div
      className={`filter-options-menu position-absolute border rounded shadow-sm ${className}`.trim()}
      style={style}
      role="listbox"
      onClick={(e) => e.stopPropagation()}
    >
      {options.map((option) => {
        const isSelected = value === option;
        return (
          <button
            key={option}
            type="button"
            role="option"
            aria-selected={isSelected}
            className={`filter-options-menu__item ${isSelected ? "filter-options-menu__item--selected" : ""}`}
            onClick={() => onSelect(option)}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};

export default FilterOptionsMenu;
